import { html } from "../../base/_utils";

export default function staffModal(member, path) {
    return html`
        <div class="modal staff-modal fade" tabindex="-1" id="${member.id}-modal" data-utl-handled="true" aria-hidden="true" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-xl">
                <div class="modal-content bg-primary">
                    <div class="modal-header border-0 shadow position-relative py-4">
                        <img class="header-waves object-fit-cover position-absolute top-0 start-0" src="${path}assets/media/global/elements/header-waves.webp" alt="wave pattern" />
                        <p class="modal-title h4 ls-lg-3 text-uppercase text-white position-relative z-1">Husker Athletic Fund | Staff Bios</p>
                        <button class="modal-close position-absolute top-0 end-0 border-0 bg-tertiary p-2 mt-2 me-2 bg-black-hover" type="button" data-bs-dismiss="modal" aria-label="Close">
                            <i class="bi bi-x-lg fs-1 fs-md-3 fs-lg-1 text-black lh-1"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row justify-content-center gx-lg-5">
                            <div class="col-10 col-lg-4">
                                <div class="staff-img-wrapper">
                                    <img class="staff-image card-img-top position-relative z-1" src="${path}${member.image}" alt="${member.name} headshot" />
                                </div>
                            </div>
                            <div class="col-lg-6 align-content-center">
                                <h3 class="staff-name h1 text-uppercase text-white mt-3">${member.name}</h3>
                                <p class="staff-title font-primary-bold text-uppercase text-white">${member.title}</p>
                                <a class="staff-email text-uppercase text-white d-block w-fit-content mb-2" href="mailto:${member.email}">${member.email}</a>
                                <a class="staff-phone text-white d-block w-fit-content" href="tel:+1${member.phone}">${member.phone}</a>
                            </div>
                        </div>
                        <div class="row justify-content-center mt-5">
                            <div class="staff-bio col-lg-10 text-white">${member.bio}</div>
                        </div>
                    </div>
                    <div class="modal-footer border-0 py-4">
                        <img class="img-fluid mx-auto bg-primary px-5 position-relative z-1" src="${path}assets/media/global/logos/n-logo-white.svg" alt="N logo" />
                    </div>
                </div>
            </div>
        </div>
    `;
}
